<template>
    <div id="profile" class="page">
        <div class="part-1">
            <div class="container">
                <h1>{{ 'PROFILE_MAIN_TITLE' | translate }}</h1>
                <h2>{{ 'PROFILE_MAIN_SUBTITLE' | translate }}</h2>
            </div>
        </div>

        <div class="area-specific-part" v-for="(areaProgress, areaId) in allProgress" :key="areaId"
             :class="'part-' + area(areaId).css_class_name"
             style=""
        >
            <div class="container">
                <div class="row area-description-row">
                    <div class="bg-img img-responsive"></div>

                    <div class="col-xs-12 col-sm-5 col-sm-offset-7 area-description-col">
                        <h2>{{ area(areaId).name }}</h2>
                        <p>{{ area(areaId).description }}</p>

                        <button @click="continueButton" class="btn primary-btn"
                           :disabled="(areaId == currentAreaId) ? false : true"
                        >
                            {{ 'PROFILE_CONTINUE' | translate }}
                        </button>
                        <div class="area-finished-text"
                             v-if="areaId != currentAreaId"
                        >
                            {{ 'PROFILE_AREA_FINISHED' | translate }}
                        </div>
                    </div>

                </div>

                <user-progress :stats="areaProgress"
                               :show-progressbar="true"
                               :progressbar-value="areaLevelProgress(areaId)"
                               :show-leaderboard-link="(areaId == currentAreaId) ? true : false"
                ></user-progress>
            </div>
        </div>

        <!-- added 2025/04 - moved from Achievements. Akademia variant doesn't use Profile -->
        <div class="achievements-part-1">
            <div class="container">
                <h1>{{ 'ACHIEVEMENTS_MAIN_TITLE' | translate }}</h1>
                <h3>{{ currentAreaDetails.achievements_main_subtitle }}</h3>

                <div class="row achievements-title">
                    <div class="col-xs-12">
                        <h2>{{ 'ACHIEVEMENTS_UNLOCKED_TITLE' | translate }}</h2>
                    </div>
                </div>

                <div class="row achievements-row">
                    <ul class="list-group achievements-list" v-if="areThereAnyUnlocked">
                        <div class="col-xs-12 col-sm-6"
                             v-for="achievement in currentUnlockedAchievements" :key="achievement.id"
                        >
                            <list-item :img-path="achievement.image_path"
                                       :title="achievement.name" :desc="achievement.description"
                                       :tag="achievement.category_name"
                                       data-key="unlockedAchievements"
                            ></list-item>
                        </div>
                    </ul>
                    <p v-else class="empty-achievements">{{ 'NO_ACHIEVEMENTS_YET' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="achievements-part-2">
            <div class="container">

                <div class="row achievements-title">
                    <div class="col-xs-12">
                        <h2>{{ 'ACHIEVEMENTS_LOCKED_TITLE' | translate }}</h2>
                    </div>
                </div>

                <div class="row achievements-row">
                    <ul class="list-group achievements-list" v-if="areThereAnyLocked">
                        <div class="col-xs-12 col-sm-6"
                             v-for="achievement in currentLockedAchievements" :key="achievement.id"
                        >
                            <list-item :img-path="achievement.image_path"
                                       :title="achievement.name" :desc="achievement.description"
                                       :tag="achievement.category_name"
                                       data-key="lockedAchievements"
                            ></list-item>
                        </div>
                    </ul>
                    <p v-else class="empty-achievements">{{ 'ALL_ACHIEVEMENTS_UNLOCKED' | translate }}</p>
                </div>
            </div>
        </div>

        <div class="part-2"
             v-if="!ssoEnabled"
        >
            <div class="container">

                <h2>{{ 'PROFILE_EDIT_MAIN_TITLE' | translate }}</h2>

                <!--Change Password Form-->
                <div class="row">
                    <div class="col-xs-12 col-md-6 col-md-offset-3">
                        <change-password></change-password>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
    import { mapGetters } from "vuex";
    import sameHeight from "src/services/sameHeight";

    import UserProgress from "Components/common/UserProgress";
    import ChangePassword from "./ChangePassword";
    import ListItem from "Components/common/ListItem";

    export default {
        components : { UserProgress, ChangePassword, ListItem },

        created : function() {
            // @note errors are handled in httpInterceptors
            this.$store.dispatch("downloadAchievements").catch(() => {});
        },

        mounted : function() {
            setTimeout(this.equalizeHeights, 500);
            setTimeout(this.equalizeHeights, 1200);
            window.addEventListener('resize', this.equalizeHeights);
        },

        destroyed : function() {
            window.removeEventListener('resize', this.equalizeHeights);
        },

        data() {
            return {
                ssoEnabled  : config.features.ssoLogin
            };
        },

        computed : mapGetters([
            "allProgress", "currentAreaId", "area", "areaLevelProgress",
            "currentUnlockedAchievements", "currentLockedAchievements",
            "areThereAnyUnlocked", "areThereAnyLocked", "currentAreaDetails"
        ]),

        methods : {
            continueButton() { this.$router.push("/item-dashboard"); },

            equalizeHeights() {
                sameHeight.equalize("[data-key='unlockedAchievements']");
                sameHeight.equalize("[data-key='lockedAchievements']");
            }
        }
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
